import { useCallback } from "react";
import { devWarn } from "../utils/devLog";

type UseDocsHoundChat = {
	/**
	 * Method to clear thread and send a query on behalf of the user
	 *
	 * @param question - user query
	 */
	sendQuestion: (question: string) => void;

	/**
	 * Method to show or hide the chat component
	 *
	 * @param show - Whether to show or hide the chat component
	 */
	show: (show: boolean) => void;

	/**
	 * Method to clear history of the chat component
	 */
	clear: () => void;
};

export function useDocsHoundChat(): UseDocsHoundChat {
	const show = useCallback((show: boolean) => {
		const element = document.querySelector(
			"docshound-chat"
		) as DocsHoundChatElement | null;
		if (element && element.show) {
			element.show(show);
		} else {
			devWarn("DocsHound Chat component not mounted or not initialized");
		}
	}, []);

	const clear = useCallback(() => {
		const element = document.querySelector(
			"docshound-chat"
		) as DocsHoundChatElement | null;
		if (element && element.clear) {
			element.clear();
		} else {
			devWarn("DocsHound Chat component not mounted or not initialized");
		}
	}, []);

	const sendQuestion = useCallback((question: string) => {
		const element = document.querySelector(
			"docshound-chat"
		) as DocsHoundChatElement | null;
		if (element && element.sendQuestion) {
			element.sendQuestion(question);
		} else {
			devWarn("DocsHound Chat component not mounted or not initialized");
		}
	}, []);

	// Return the show and clear methods
	return { show, clear, sendQuestion };
}

export default useDocsHoundChat;
